import { isResponseCodeSuccess } from '../../tools/util'
import { useEffect, useReducer } from 'react'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { setModuleDataAction } from '../../modules/pagecache'
import { useLocation } from 'react-router-dom'
import { EXPORT_ERRORDATA } from '../../api/downfileapi'
import { GET_TASKDETAIL } from '../../api/TaskApi'
import reducer, {
  TaskDetailState,
  defaultState,
  reloadStateAction,
  setDataSourceAction,
  setDataSourceLoadingAction,
  setFileAction,
  setHeadertitleAction,
  setPagesAction,
  setTaskIdAction,
} from './reducer'

const useTaskDetailHook = () => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const { taskId } = state
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<{
    taskId: string
    fileUrl: string
    fileName: string
    init?: string
  }>()
  const dispatchredux = useDispatch()

  useEffect(() => {
    if (location.state) {
      // 存id
      const id = location.state.taskId
      dispatch(setTaskIdAction(id))
      dispatch(
        setPagesAction({
          pageNo: 1,
          pageSize: 25,
        }),
      )
      // 获取数据 没有id
      getdata({ ...state, ...{ taskId: id } })
    } else {
      const flag = getpagecache()
      dispatch(reloadStateAction(flag))
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: state,
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 获取列表数据
  const getdata = async (state: TaskDetailState) => {
    // 在saga处理中 获取state
    const params = { ...state.pages }
    // 添加loading
    dispatch(setDataSourceLoadingAction(true))
    const res = await GET_TASKDETAIL({
      id: state.taskId,
      pageSize: params.pageSize, // 分页尺寸
      pageNo: params.pageNo, // 页码
    })
    dispatch(setDataSourceLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data
      const count = res.data.pageDataList.totalCount
      const taskResult = resdata.reason
      const taskResultType = resdata.type
      const taskResultState = resdata.state
      const link = {
        fileUrl: `${resdata.link}`,
        fileName: resdata.fileName,
      }
      dispatch(setFileAction(link))
      const arr = resdata.pageDataList.content.map((item: any) => ({
        ...item,
      }))
      const action = setDataSourceAction({
        dataSource: { data: arr, total: count },
        pageNo: res.data.pageDataList.pageNo,
      })
      dispatch(action)
      // 设置任务标题和结果
      dispatch(
        setHeadertitleAction({
          taskResult: taskResult,
          taskResultType: taskResultType,
          taskResultState: taskResultState,
        }),
      )
    }
  }

  // 分页
  const onChange = (pageNo: number, pageSize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 导出数据
  const onClickdown = () => {
    EXPORT_ERRORDATA({ id: taskId })
  }

  return {
    hookstate: state,
    onChange,
    onClickdown,
  }
}

export default useTaskDetailHook
import { isResponseCodeSuccess } from '../../tools/util'
import { useEffect, useReducer } from 'react'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { setModuleDataAction } from '../../modules/pagecache'
import { useLocation } from 'react-router-dom'
import { EXPORT_ERRORDATA } from '../../api/downfileapi'
import { GET_TASKDETAIL } from '../../api/TaskApi'
import reducer, {
  TaskDetailState,
  defaultState,
  reloadStateAction,
  setDataSourceAction,
  setDataSourceLoadingAction,
  setFileAction,
  setHeadertitleAction,
  setPagesAction,
  setTaskIdAction,
} from './reducer'

const useTaskDetailHook = () => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const { taskId } = state
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<{
    taskId: string
    fileUrl: string
    fileName: string
    init?: string
  }>()
  const dispatchredux = useDispatch()

  useEffect(() => {
    if (location.state) {
      // 存id
      const id = location.state.taskId
      dispatch(setTaskIdAction(id))
      dispatch(
        setPagesAction({
          pageNo: 1,
          pageSize: 25,
        }),
      )
      // 获取数据 没有id
      getdata({ ...state, ...{ taskId: id } })
    } else {
      const flag = getpagecache()
      dispatch(reloadStateAction(flag))
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: state,
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 获取列表数据
  const getdata = async (state: TaskDetailState) => {
    // 在saga处理中 获取state
    const params = { ...state.pages }
    // 添加loading
    dispatch(setDataSourceLoadingAction(true))
    const res = await GET_TASKDETAIL({
      id: state.taskId,
      pageSize: params.pageSize, // 分页尺寸
      pageNo: params.pageNo, // 页码
    })
    dispatch(setDataSourceLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data
      const count = res.data.pageDataList.totalCount
      const taskResult = resdata.reason
      const taskResultType = resdata.type
      const taskResultState = resdata.state
      const link = {
        fileUrl: `${resdata.link}`,
        fileName: resdata.fileName,
      }
      dispatch(setFileAction(link))
      const arr = resdata.pageDataList.content.map((item: any) => ({
        ...item,
      }))
      const action = setDataSourceAction({
        dataSource: { data: arr, total: count },
        pageNo: res.data.pageDataList.pageNo,
      })
      dispatch(action)
      // 设置任务标题和结果
      dispatch(
        setHeadertitleAction({
          taskResult: taskResult,
          taskResultType: taskResultType,
          taskResultState: taskResultState,
        }),
      )
    }
  }

  // 分页
  const onChange = (pageNo: number, pageSize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 导出数据
  const onClickdown = () => {
    EXPORT_ERRORDATA({ id: taskId })
  }

  return {
    hookstate: state,
    onChange,
    onClickdown,
  }
}

export default useTaskDetailHook
